import Errors from './Errors';

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {

        this.originalData = data;

        this.formDataAttachments = [];

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {

        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }


    /**
     * Fetch all relevant data for the form.
     */
    dataAsFormData() {

        let data = new FormData();

        for (let property in this.originalData) {

            if (typeof this[property] === "undefined" || this[property] === null) {

                data.append(property, '');

            } else if (typeof this[property] === "object") {

                data.append(property, JSON.stringify(this[property]));

            } else {

                data.append(property, this[property]);
            }
        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }


    /**
     * Clear any form errors
     */
    clearErrors() {
        this.errors.clear();
    }


    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('post', url);
    }


    /**
     * Send a POST request to the given URL, but use Multipart content type
     * .
     * @param {string} url
     */
    postMultipart(url, callback) {
        return this.submit('post', url, true, callback);
    }


    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     * @param {bool}   isMultipart
     */
    submit(requestType, url, isMultipart, callback) {

        return new Promise((resolve, reject) => {

            let startFormData = this.dataAsFormData();

            let axiosConfig = {};

            if (isMultipart !== undefined && isMultipart === true) {
                axiosConfig = { headers: { 'Content-Type': 'multipart/form-data' }};
            }

            if (callback !== undefined) {
                startFormData = callback(startFormData);
            }

            axios[requestType](url, startFormData, axiosConfig)
                .then(response => {
                    //this.onSuccess(response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    this.onFail(error.response.data);
                    reject(error.response);
                });
        });
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        this.reset();
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors);
    }
}

export default Form;
